module.exports = __webpack_public_path__ + "static/media/arrow_down.a319602a.svg";